// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_js_components_embed_EmbedFormComponent_vue-_46801":1,"resources_js_components_embed_EmbedFormBusiness_vue":1,"resources_js_components_ValidationErrorComponent_vue-_165a1":1}[chunkId]) return "assets/js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};